import { motion } from "framer-motion";

export default function SectionHeader({ eyebrow, title, subtitle, align = "left", titleAccent, dark = false }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <div className="eyebrow mb-4">{eyebrow}</div>}
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className={`text-3xl md:text-5xl font-bold leading-[1.05] tracking-tight ${dark ? "text-white" : "text-slate-900"}`}
        style={{ fontFamily: "'Outfit', sans-serif" }}
      >
        {title}{" "}
        {titleAccent && (
          <span className="text-[color:var(--brand)]">{titleAccent}</span>
        )}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className={`mt-5 text-base md:text-lg ${dark ? "text-slate-400" : "text-slate-600"} max-w-2xl ${align === "center" ? "mx-auto" : ""}`}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}
